import { render, staticRenderFns } from "./WorkClientContact.vue?vue&type=template&id=613648ce&"
import script from "./WorkClientContact.vue?vue&type=script&lang=js&"
export * from "./WorkClientContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports